import jquery from 'jquery';
import URL from '@/tools/url';
import { setupCsrfToken } from '@/ajax/shop/helpers/setupCsrfToken';

/**
 * Построение корректного URL для отправки комментариев
 * @param {String} articleUrl - URL статьи
 * @returns {String} - URL для отправки комментариев
 */
function buildCommentsUrl(articleUrl) {
  try {
    const url = new URL(articleUrl, window.location.origin);

    return url.origin + url.pathname + '/comments.json';
  } catch (catchError) {
    // Фоллбек для случаев, когда URL некорректный
    // Убираем GET-параметры вручную
    const cleanUrl = articleUrl.split('?')[0].split('#')[0];

    return cleanUrl + '/comments.json';
  }
}

/**
 * @description
 * Отправка отзыва к товару
 *
 * @param {Object} comment - объект с комментарием. ОБЯЗАТЕЛЬНО
 * @param {String} comment.author - автор комментария. ОБЯЗАТЕЛЬНО
 * @param {String} comment.email - e-mail посетителя. ОБЯЗАТЕЛЬНО
 * @param {String} comment.content - тело комментария.ОБЯЗАТЕЛЬНО
 * @param {String} comment.captcha_solution - капча. ОБЯЗАТЕЛЬНО
 * @param {String} comment.captcha_challenge - капча. ОБЯЗАТЕЛЬНО
 * @param {String} articleUrl - url товара, к которому хотим оставить отзыв
 *
 * @return {Promise} - поток выполнения задачи
 */
export default function(comment, articleUrl) {
  setupCsrfToken();

  const _result = jquery.Deferred();
  const _lang = URL.getKeyValue('lang') || '';
  const _comment = {
    comment: comment,
    recaptcha_type: comment.recaptcha_type,
    lang: _lang
  };

  // Правильно формируем URL для отправки комментария
  const _commentsUrl = buildCommentsUrl(articleUrl);

  jquery.post(_commentsUrl, _comment)
    .done(function(response) {
      if (response.errors) {
        _result.reject(response);
      } else {
        _result.resolve({
          status: 'ok',
          published: response.comment.published
        });
      }
    });

  return _result.promise();
}
